import { Send } from 'iconsax-react';
import MicrophoneIcon from '@/assets/images/icons/microphone.svg?react';
import ProgressButton from '@/components/common/progress-button';
import useConversationForm from '@/hooks/conversations/use-conversation-form';

type Props = {
  isLoading?: boolean;
  disabled?: boolean;
};

export default function ConversationFormButton({ isLoading, disabled }: Props) {
  const { form, canRecord, isRecorderOpen, toggleRecorderOpen } = useConversationForm();
  const content = form.watch('Content');
  const attachments = form.watch('Attachment');

  if (isLoading || content?.trim() || attachments?.length || !canRecord) {
    return (
      <ProgressButton
        as='submit'
        onPointerDown={(e) => e?.preventDefault()}
        onMouseDown={(e) => e?.preventDefault()}
        disabled={disabled}
        tabIndex={0}
        icon={
          <Send
            variant='Bold'
            className='size-6 text-primary'
          />
        }
        isLoading={isLoading || form.formState.isValidating}
        className='btn btn-square btn-ghost btn-sm ring-0'
      />
    );
  }

  if (canRecord && !isRecorderOpen) {
    return (
      <button
        type='button'
        disabled={disabled}
        onClick={toggleRecorderOpen}
        className='btn btn-square btn-ghost btn-sm ring-0'>
        <MicrophoneIcon className='size-6' />
      </button>
    );
  }

  return null;
}
